<template>
  <div :class="{'jom-table':true,'rc_mode':layout=='rc'}">
    <div :id="data.id">
      <!-- 表头Start -->
      <div v-if="this.data.caption.length > 0" class="jom-main-title theme-font">
        <span>
          <component :is="'jo' + item.name" v-for="item in this.data.caption[0].label" v-bind:key="item.index"
                     v-bind:data="item.data"></component>&nbsp;
          <component :is="'jo' + item.name" v-for="item in this.data.caption[0].title" v-bind:key="item.index"
                     v-bind:data="item.data"></component>
        <span v-if="this.data.caption[0].label && this.data.cellunit">
          <span v-for="item1 in this.data.cellunit" v-if="item1.lang==data.caption[0].lang">(
          <component :is="'jo' + item.name" v-for="item in item1.data" v-bind:key="item.index"
                     v-bind:data="item.data"></component>
          )</span>
        </span>
        </span>
      </div>

      <div v-if="this.data.caption.length > 1" class="jom-sub-title theme-font">
        <span>
          <component :is="'jo' + item.name" v-for="item in this.data.caption[1].label" v-bind:key="item.index"
                         v-bind:data="item.data"></component>&nbsp;
          <component :is="'jo' + item.name" v-for="item in this.data.caption[1].title" v-bind:key="item.index"
                   v-bind:data="item.data"></component>
        <span v-if="this.data.caption[1].label && this.data.cellunit">
          <span v-for="item1 in this.data.cellunit" v-if="item1.lang==data.caption[1].lang">(
          <component :is="'jo' + item.name" v-for="item in item1.data" v-bind:key="item.index"
                     v-bind:data="item.data"></component>
          )</span>
        </span>
        </span>
      </div>
      <!-- 表头End -->

      <!--表前图-->
      <div v-if="this.data.beforegraphics" style="overflow-x: auto" align="center">
        <img v-for="graphic in this.data.beforegraphics" :src="graphic.big" :style="{ 'width': calWidth(graphic.width) + 'px', 'height': calHeight(graphic.height) + 'px', 'max-width' : '100%'}" alt="table"/>
      </div>

      <div style="overflow-x: auto; overflow-y: hidden" v-for="(tableItem,tableIndex) in data.table" :key="data.id + tableIndex">
        <table cellspacing="0" cellpadding="0" ref="table" :border="setCellStyle(tableItem.style,true)"
               v-if="tableItem.head.length > 0 || tableItem.body.length > 0">
          <thead v-if="tableItem.head.length > 0" >
          <tr v-for="(item, index) in tableItem.head" v-bind:key="index">
            <th v-for="(item2, index2) in item" v-bind:key="index2" :rowspan="item2.rowspan" :colspan="item2.colspan"
                :align="item2.align"
                :style="setCellStyle(item2.style,false)">
              <component :is="'jo' + item3.name" v-for="item3 in item2.data" v-bind:key="item3.index"
                         v-bind:data="item3.data"></component>
            </th>
          </tr>
          </thead>
          <tbody v-if="tableItem.body.length > 0">
          <tr v-for="(item, index) in tableItem.body" v-bind:key="index">
            <td v-for="(item2, index2) in item" v-bind:key="index2" :rowspan="item2.rowspan" :colspan="item2.colspan"
                :align="item2.align"
                :style="setCellStyle(item2.style,false)">
              {{ item2.index }}
              <component :is="'jo' + item3.name" v-for="item3 in item2.data" v-bind:key="item3.index"
                         v-bind:data="item3.data"></component>
            </td>
          </tr>
          </tbody>
          <tfoot v-if="tableItem.foot && tableItem.foot.length > 0">
          <tr v-for="(item, index) in tableItem.foot" v-bind:key="index">
            <td v-for="(item2, index2) in item" v-bind:key="index2" :rowspan="item2.rowspan" :colspan="item2.colspan"
                :align="item2.align"
                :style="setCellStyle(item2.style,false)">
              {{ item2.index }}
              <component :is="'jo' + item3.name" v-for="item3 in item2.data" v-bind:key="item3.index"
                         v-bind:data="item3.data"></component>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>

      <div class="jom-table-note" v-if="this.data.note.length > 0">
        <div v-for="note in this.data.note">
          <!--<span v-if="note.data[0].name && note.data[0].name != 'vocab'"
                class="label" style="font-weight: bold;">{{note.lang == 'zh' ? '注：' : 'NOTE:'}}</span>-->
          <span v-for="(item, index) in note.data">
          <component :is="'jo' + item.name" class="note" v-bind:key="item.index"
                      v-bind:data="item.data"></component>
          <span v-if="index < note.data.length - 1 && !hasColon(item)">{{note.lang=='zh'?'；':'; '}}</span>
        </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import joinlineformula from '../formula/inlineformula.vue'
  import jointablefig from '../fig/intablefig.vue'
  import joinlinegraphic from '../fig/inlinegraphic.vue'

  export default {
    components: {
      jointablefig,
      joinlineformula,
      joinlinegraphic
    },
    props: [
      'data'
    ],
    data() {
      return {
        isShowBigTable: false,
        picHeight: "inherit",
        wrapWidth: 1,
        tableWidth: 1,
        tableHeight: 1,
        scaleValue: 1,
        scrollTop: 0,
//        hideVocab:true,
        tableNoteDisplay:'none'
      }
    },
    watch: {

    },
    mounted() {
      this.wrapWidth = $('.jom-table').width();
      let _this = this;
      setTable();
      function setTable () {
        _this.tableHeight = $(_this.$refs.table).height();
        _this.tableWidth = $(_this.$refs.table).width();
      }
      let imgs = $(this.$refs.table).find('img');
      let num = imgs.length;
      if (num > 0) {
        imgs.each(function () {
          if (this.getAttribute('src') === null) {
            num--;
            return
          }
          let img = new Image();
          img.src = this.getAttribute('src')
          img.onload = function () {
            num--;
            if (num < 1) {
              setTable()
            }
          }
        })
      }
      MathJax.Hub.Queue(["Typeset", MathJax.Hub],[setTable])

      $(window).on('resize', function () {
        // $("#"+_this.data.id+" table").css({transform:''})
        _this.tableWidth = $(_this.$refs.table).width();
        _this.wrapWidth = $('.jom-table').width();
        _this.tableHeight = $(_this.$refs.table).height();
      })
    },
    methods: {
      showBigTable() {
        this.isShowBigTable = true;
      },
      calWidth(width){
        return width * this.GLOBAL.deviceDPI.x / 25.4
      },
      calHeight(height){
        return height * this.GLOBAL.deviceDPI.y / 25.4
      },
      setCellStyle(style,isOut){
        let border;
        let borderWidth = 1;
        if (isOut){
          borderWidth = 2;
        }
        if (style && style!==''){
          border = style + ';border-width:'+borderWidth+'px;border-color: #333;'
          if (style.search(/border-top:Double/i)>=0){
            border += ';border-top-width:3px;';
          }
          if (style.search(/border-right:Double/i)>=0){
            border += ';border-right-width:3px;';
          }
          if (style.search(/border-bottom:Double/i)>=0){
            border += ';border-bottom-width:3px;';
          }
          if (style.search(/border-left:Double/i)>=0){
            border += ';border-left-width:3px;';
          }
        }
        return border;
      },
      hasColon(item){
        let hasColon = false;
        if (item.name === 'p'){
          hasColon = this.hasColon(item.data[item.data.length-1]);
        } else if (item.name==='text'){
          if(item.data.lastIndexOf(';')===item.data.length-1 ||
            item.data.lastIndexOf('；')===item.data.length-1){
            return true
          }
        }
        return hasColon;
      }
    },
  }
</script>
<style lang="scss" scoped>
  /* eslint-disable */
  .jom-main-title, .jom-sub-title {
    text-align: center;
    font-size: 1.2rem;
    line-height: 18px;
    color: #00A2AF;
    font-weight: bold;
    margin-bottom: 5px;
    max-width: 100%;
  }

  .jom-main-title {
    margin-top: 20px;
  }

  .jom-sub-title {
    margin-bottom: 20px;
  }

  /* 重写干扰部分 */
  .jom-main-title .jom-sup, .jom-sub-title .jom-sup {
    display: inline-block;
  }

  .jo-table-border-none {
    border: none !important;
  }

  .outside-top-border{
    border-collapse: collapse;
    border-top: 2px solid #333;
  }

  .outside-bottom-border {
    border-collapse: collapse;
    border-bottom: 2px solid #333;
  }

  .jom-table {
    background-color: #ffffff;
    margin: 1.5rem 0px;
    table {
      border-collapse: collapse;
      border-top:solid 2px #333;
      border-bottom:solid 2px #333;
      border-left: none;
      border-right: none;
      width: 100%;
      margin-top: 10px;
      transform-origin: 0 0;
      thead {
        th {
          min-width: 80px;
          padding: 5px;
          border: none;
          font-size: 1.4rem;
          color: #333;
          max-width: 300px;
          word-break: normal;
        }
      }
      tbody {
        td {
          min-width: 80px;
          padding: 5px;
          border: none;
          font-size: 1.4rem;
          color: #333;
          max-width: 300px;
          word-break: normal;
        }
      }
      tfoot {
        td {
          border: none;
          font-size: 1.4rem;
          color: #333;
          padding: 5px;
          max-width: 300px;
          word-break: normal;
        }
      }
      span {
        height: 30px;
        display: inline;
        line-height: 30px;
        font-size: 14px;
        color: #333;
      }
    }
    p {
      line-height: initial;
      margin-bottom: 0;
      text-indent: 0;
      color: #000;
      text-align: inherit;
      min-height: 24px;
    }
  }

  .jom-table-note {
    margin: 6px 0;
    text-align: left;
    .label {
      display: inline-block;
    }
    .note {
      display: inline;
      line-height: 18px;
      /*font-size: 1.2rem;*/
    }
  }
</style>

<style>

  table .jom-inlineformula .jom-inlineformula1{
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/table/table.vue